import { Box, Card, Stack, Typography } from "@mui/material";
import { PRODUCTS } from "../content";
import { PageContainer, SectionHeading, sectionSx } from "./SectionLayout";

function ProductCard({ product }) {
  return (
    <Card
      elevation={0}
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2.5,
        boxShadow: "0 14px 38px rgba(93, 63, 211, 0.07)",
        overflow: "hidden",
        transition: "transform 180ms ease, box-shadow 180ms ease",
        "&:hover": {
          boxShadow: "0 22px 48px rgba(93, 63, 211, 0.12)",
          transform: "translateY(-4px)"
        }
      }}
    >
      <Stack
        direction="row"
        spacing={0.75}
        sx={{
          bgcolor: "landing.surfaceLow",
          borderBottom: "1px solid",
          borderColor: "divider",
          p: 1.75
        }}
      >
        {["#e6a3a3", "#f6cd70", "#78c9a8"].map((color) => (
          <Box key={color} sx={{ bgcolor: color, borderRadius: "50%", height: 7, width: 7 }} />
        ))}
      </Stack>
      <Box
        component="img"
        src={product.image}
        alt={product.alt}
        loading="lazy"
        sx={{
          aspectRatio: "16 / 9",
          borderBottom: "1px solid",
          borderColor: "divider",
          display: "block",
          objectFit: "cover",
          width: "100%"
        }}
      />
      <Box sx={{ p: { xs: 2.5, md: 3.5 }, textAlign: "center" }}>
        <Typography component="h3" sx={{ fontSize: 17, fontWeight: 800 }}>
          {product.title}
        </Typography>
        <Typography color="text.secondary" sx={{ fontSize: 13, mt: 1 }}>
          {product.description}
        </Typography>
      </Box>
    </Card>
  );
}

export default function ProductsSection() {
  return (
    <Box component="section" sx={sectionSx}>
      <PageContainer sx={{ maxWidth: 1360 }}>
        <SectionHeading title="One Platform. Complete Hiring Solution." />
        <Box
          sx={{
            display: "grid",
            gap: 3,
            gridTemplateColumns: { xs: "1fr", md: "repeat(2, minmax(0, 1fr))" }
          }}
        >
          {PRODUCTS.map((product) => (
            <ProductCard key={product.title} product={product} />
          ))}
        </Box>
      </PageContainer>
    </Box>
  );
}
